import { AnimatePresence, motion } from "framer-motion";
import { FileEditor } from "./FileEditor";

interface FileEditorPanelProps {
	open: boolean;
	path: string;
	onSave?: (path: string, content: string) => Promise<void>;
	onClose: () => void;
}

export function FileEditorPanel({ open, path, onSave, onClose }: FileEditorPanelProps) {
	return (
		<AnimatePresence>
			{open && (
				<>
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						className="fixed inset-0 bg-black/30 z-40"
						onClick={onClose}
					/>
					<motion.div
						initial={{ opacity: 0, x: 400 }}
						animate={{ opacity: 1, x: 0 }}
						exit={{ opacity: 0, x: 400 }}
						transition={{ type: "spring", damping: 25, stiffness: 200 }}
						className="fixed inset-y-0 right-0 w-full max-w-2xl bg-card border-l border-border z-50 flex flex-col shadow-2xl"
					>
						<FileEditor path={path} onSave={onSave} onClose={onClose} />
					</motion.div>
				</>
			)}
		</AnimatePresence>
	);
}
